export class ParentProperty{
    Name: string;
    Value: number;

    constructor(name: string, value: number){
        this.Name = name;
        this.Value = value;
    }
}